import {AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit} from "@angular/core";
import {AgentLeadType, FelloVisitorVariables} from "fello-model";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {environment} from "../../../../../../environments/environment";
import {ActivatedRoute, Router} from "@angular/router";
import {FELLO_API_SERVICE_BASE_URL, FelloWebsites, GlobalTrackingEventService, TrackedEvents, TrackerUsers} from "fello-common";
import {take, takeUntil} from "rxjs/operators";
import {MatDialog} from "@angular/material/dialog";
import {WhyEmailNeededComponent} from "../../dialogs/why-email-needed/why-email-needed.component";
import {JourneySettingsService} from "../../../services/journey-settings.service";

declare const AppleID: any;

@Component({
  selector: "app-que-log-in",
  templateUrl: "./que-log-in.component.html",
  styleUrls: ["./que-log-in.component.scss"]
})
export class QueLogInComponent extends QuestionCardDirective implements AfterViewInit, OnInit {
  userEmail: string;
  appleScriptLoaded = false;
  AgentLeadType = AgentLeadType;

  setting$ = this.journeySettingsService.settings$;

  get leadType(): AgentLeadType {
    return this.offerJourney.leadType!;
  }

  protected readonly felloWebsites = FelloWebsites;

  constructor(
    public offerJourneyService: OfferJourneyService,
    @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(FELLO_API_SERVICE_BASE_URL) private baseUrl: string,
    private cd: ChangeDetectorRef,
    private globalTrackingEventService: GlobalTrackingEventService,
    private dialog: MatDialog,
    private journeySettingsService: JourneySettingsService
  ) {
    super(offerJourneyService, taskId);
    this.userEmail = this.offerJourney.vars.userEmail ?? "";
  }

  ngOnInit(): void {
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      if (params.email) {
        this.userEmail = params.email;
        this.next();
      }
    });
  }

  ngAfterViewInit(): void {
    this.offerJourneyService
      .loadAppleAuthenticationScript()
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(() => {
        AppleID.auth.init({
          clientId: environment.appleAuthClientId,
          scope: `name email`,
          redirectURI: `${this.baseUrl}/fello/auth/apple-sign-in`,
          state: `${window.location.href}`
        });
        this.appleScriptLoaded = true;
      });
  }

  continueWithApple(): void {
    AppleID.auth.signIn();
  }

  next(): void {
    const vars: FelloVisitorVariables = {
      userEmail: this.userEmail
    };
    this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars).subscribe(() => {
      this.cd.detectChanges();
      this.globalTrackingEventService.userIdentified(vars.userEmail!, {
        type: TrackerUsers.HOME_OWNER
      });
      this.globalTrackingEventService.trackCustomEvent(TrackedEvents.CONTACT_RECEIVED, {
        type: TrackerUsers.HOME_OWNER,
        email: vars.userEmail!
      });
    });
    this.router.navigate([], {
      queryParams: {
        email: null
      },
      queryParamsHandling: "merge"
    });
    this.cd.detectChanges();
  }

  openWhyDialog() {
    this.dialog.open(WhyEmailNeededComponent, {
      panelClass: ["mobile-bottom-sheet"],
      data: this.journeyType
    });
  }
}
